export interface ErrorWithHelp extends OT.OTError {
  helpLink: string;
}

export function withHelpLink(arg: any): arg is ErrorWithHelp {
  return arg && arg.helpLink && typeof arg.helpLink === 'string';
}
